
import Headphone from "../../../assets/filled/Headphone.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HeadphoneIcon({ className, dataTestid = "HeadphoneIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Headphone data-testid={dataTestid} className={classes} {...rest} />
  );
}
